/**
 * Engine API
 * Engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This model matches the backend EmailStatsDto
 */

export interface EmailStatsDto {
    stepPath?: string;
    totalEmails?: number;
    successfulEmails?: number;
    failedEmails?: number;
    recipients?: EmailRecipientDto[];
}

export interface EmailRecipientDto {
    email?: string;
    name?: string;
    status?: string;
    errorType?: string;
    errorMessage?: string;
}
